import { Order } from '@/types';
import { bem, dayOfWeeks, doubleDigestNumer } from '@/utilities';
import React from 'react';
import { Link } from 'react-router-dom';
import { OrderStatus } from './ordersIndex';

const oneDayLaterTime = new Date();
oneDayLaterTime.setDate(oneDayLaterTime.getDate() + 1);

type Props = {
  status: OrderStatus;
  orders: Order[];
  token: string;
  onClickCancelLink: (order: Order) => void;
};

export const OrdersList: React.FC<Props> = (props) => {
  const { status, orders, token, onClickCancelLink } = props;

  const formattedScheduledAtDate = (order: Order) => {
    const dateScheduledAt = new Date(order.scheduledAt);
    return (
      `${dateScheduledAt.getFullYear()}年${dateScheduledAt.getMonth() + 1}月` +
      `${dateScheduledAt.getDate()}日（${dayOfWeeks[dateScheduledAt.getDay()]}）`
    );
  };

  const formattedScheduledAtTime = (order: Order) => {
    const dateScheduledAt = new Date(order.scheduledAt);
    const endAt = new Date(dateScheduledAt.getTime() + order.duration * 1000 * 60);

    return (
      `${dateScheduledAt.getHours()}:${doubleDigestNumer(dateScheduledAt.getMinutes())}〜` +
      `${endAt.getHours()}:${doubleDigestNumer(endAt.getMinutes())}`
    );
  };

  return (
    <div className={bem('orders', 'list')}>
      {orders.map((order) => (
        <div className={bem('orders', 'item')} key={order.id}>
          {status !== 'unassigned' && (
            <>
              <p className={bem('orders', 'item-schedule')}>
                {`${formattedScheduledAtDate(order)} ${formattedScheduledAtTime(order)}`}
              </p>
              <p className={bem('orders', 'item-schedule-date')}>{formattedScheduledAtDate(order)}</p>
              <p className={bem('orders', 'item-schedule-time')}>{formattedScheduledAtTime(order)}</p>
            </>
          )}
          <div className={bem('orders', 'item-body')}>
            <div>
              <div className={bem('orders', 'item-flex-wrapper')}>
                <div className={bem('orders', 'item-car')}>
                  {order.carManagementNumber && (
                    <p className={bem('orders', 'item-car-text')}>
                      <span>{order.carManagementNumber}</span>
                    </p>
                  )}
                  <p className={bem('orders', 'item-car-text')}>
                    <span>{order.ownedCar.carNumber}</span>
                  </p>
                  {order.ownedCar.vehicleNumber && (
                    <p className={bem('orders', 'item-car-text')}>
                      <span>{order.ownedCar.vehicleNumber}</span>
                    </p>
                  )}
                  <p className={bem('orders', 'item-car-text')}>{order.ownedCar.carModelName}</p>
                  <p className={bem('orders', 'item-car-text')}>{order.ownedCar.carModelNumber}</p>
                </div>
                <p className={bem('orders', 'item-time')}>{`${order.duration}分`}</p>
              </div>
              {!!order.directScheduleCustomerMemo && (
                  <div className={bem('orders','item-flex-wrapper')}>
                    <div className={bem('orders', 'item-memo')}>
                        ご連絡事項: {`${order.directScheduleCustomerMemo}`}
                    </div>
                  </div>
              )}
              <div className={bem('orders', 'item-flex-wrapper')}>
                <p className={bem('orders', 'item-location')}>{order.location}</p>
                <p className={bem('orders', 'item-name')}>{`${order.userName}様`}</p>
              </div>
            </div>
            {status === 'unassigned' && (
                <div>
                    <Link
                        to={`/schedule_adjustments/${token}?select_order_id=${order.id}`}
                        className={bem('orders', 'item-button')}
                    >
                        日程調整
                    </Link>
                </div>
            )}
            {status === 'scheduled' && new Date(order.scheduledAt) > oneDayLaterTime && (
              <p className={bem('orders', 'item-link')} onClick={() => onClickCancelLink(order)}>
                予約の取り消し
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
